import { IApiError } from '@/models/apiError.model';
import { IProgressStep, IPropertyOwner } from '@/models/property.model';
import { StepsProgresses } from '@/models/propertyProgress.model';
import { StepType } from '@/models/step.model';

export const PROPERTY_PROGRESS_SLICE_NAME = 'property_progress';

export interface PropertyProgressState {
  propertyOwner: IPropertyOwner | null;
  totalOrdersSum: number;
  stepsProgresses: Partial<Record<StepType, StepsProgresses>> | null;
  progress: IProgressStep[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: PropertyProgressState = {
  totalOrdersSum: 0,
  stepsProgresses: null,
  progress: null,
  propertyOwner: null,
  isLoading: false,
  error: null,
};
